import React, { forwardRef, HtmlHTMLAttributes, memo, ReactNode } from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";

export type NotFoundBlockProps = HtmlHTMLAttributes<HTMLDivElement> & {
  header?: string
  actions?: ReactNode
  errorText?: string
  supportingText?: string
  headerClassName?: string
  actionsClassName?: string
  errorTextClassName?: string
  supportingTextClassName?: string
}

export const NotFoundBlock = memo(forwardRef<HTMLDivElement, NotFoundBlockProps>((
  {
    header = "We can’t find that page",
    actions,
    className,
    errorText = "404 error",
    supportingText = "Sorry, the page you are looking for doesn't exist or has been moved.",
    headerClassName,
    actionsClassName,
    errorTextClassName,
    supportingTextClassName,
    ...props
  },
  ref
) => {

  return (
    <div
      className={classNames(
        styles.root,
        className
      )}
      {...props}
      ref={ref}
    >
      {errorText &&
        <span className={classNames(styles.errorText, errorTextClassName)}>{errorText}</span>
      }
      {
        header &&
        <h4 className={classNames(styles.header, headerClassName)}>{header}</h4>
      }
      {
        supportingText &&
        <div className={classNames(styles.supportingText, supportingTextClassName)}>{supportingText}</div>
      }
      {
        actions &&
        <div className={classNames(styles.actions, actionsClassName)}>{actions}</div>
      }
    </div>
  );
}));